export default __webpack_public_path__ + "static/media/main-logo.de359a4a.png";